import _objectWithoutProperties from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["htmlFor", "id"];
import { useId as e } from "@radix-ui/react-id";
import { Primitive as t } from "@radix-ui/react-primitive";
import { useComposedRefs as r } from "@radix-ui/react-compose-refs";
import { createContext as o } from "@radix-ui/react-context";
import * as l from "react";
import n from "@babel/runtime/helpers/esm/extends";

var _o = o("Label", {
  id: void 0,
  controlRef: {
    current: null
  }
}),
    _o2 = _slicedToArray(_o, 2),
    i = _o2[0],
    a = _o2[1];

export var Label = /*#__PURE__*/l.forwardRef(function (o, a) {
  var c = o.htmlFor,
      u = o.id,
      s = _objectWithoutProperties(o, _excluded),
      d = l.useRef(null),
      f = l.useRef(null),
      m = r(a, f),
      b = e(u);

  return l.useEffect(function () {
    if (c) {
      var _e = document.getElementById(c);

      if (f.current && _e) {
        var _t = function _t() {
          return _e.getAttribute("aria-labelledby");
        },
            _r = [b, _t()].filter(Boolean).join(" ");

        return _e.setAttribute("aria-labelledby", _r), d.current = _e, function () {
          var r;
          var o = null === (r = _t()) || void 0 === r ? void 0 : r.replace(b, "");
          "" === o ? _e.removeAttribute("aria-labelledby") : o && _e.setAttribute("aria-labelledby", o);
        };
      }
    }
  }, [b, c]), /*#__PURE__*/l.createElement(i, {
    id: b,
    controlRef: d
  }, /*#__PURE__*/l.createElement(t.span, n({
    role: "label",
    id: b
  }, s, {
    ref: m,
    onMouseDown: function onMouseDown(e) {
      var t;
      null === (t = o.onMouseDown) || void 0 === t || t.call(o, e), !e.defaultPrevented && e.detail > 1 && e.preventDefault();
    },
    onClick: function onClick(e) {
      var t;
      if (null === (t = o.onClick) || void 0 === t || t.call(o, e), !d.current || e.defaultPrevented) return;
      var r = d.current.contains(e.target),
          l = !0 === e.isTrusted;
      !r && l && (d.current.click(), d.current.focus());
    }
  })));
});
/*#__PURE__*/

export var useLabelContext = function useLabelContext(e) {
  var t = a("LabelConsumer"),
      r = t.controlRef;
  return l.useEffect(function () {
    e && (r.current = e);
  }, [e, r]), t.id;
};
export var Root = Label;